import { useRef, useState } from 'react';

import { IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';

import './styles/reorganize-modal.css';

// Generic drag-and-drop reorder. `items`: [{ id, label }]. Returns the new order
// (array of id) on apply. Native HTML5 DnD (no dependency).

export default function ReorganizeModal({ items, onApply, onClose }) {
    const [list, setList] = useState(items);
    const dragIndex = useRef(null);
    const cardRef = useModalDialog(onClose);

    const onDragStart = (i) => { dragIndex.current = i; };
    const onDragOver = (e, i) => {
        e.preventDefault();
        const from = dragIndex.current;
        if (from === null || from === i) return;
        setList((prev) => {
            const next = [...prev];
            const [moved] = next.splice(from, 1);
            next.splice(i, 0, moved);
            return next;
        });
        dragIndex.current = i;
    };
    const onDragEnd = () => { dragIndex.current = null; };

    return (
        <div className="reorg">
            <div className="reorg__overlay" onClick={onClose} aria-hidden="true" />
            <div className="reorg__card" role="dialog" aria-modal="true" aria-label="Reorganizar" ref={cardRef}>
                <header className="reorg__head">
                    <h2 className="reorg__title">Reorganizar donantes</h2>
                    <button type="button" className="reorg__close" onClick={onClose} aria-label="Cerrar"><IconClose /></button>
                </header>

                <p className="reorg__hint">Arrastrá para cambiar el orden de las filas.</p>

                <ul className="reorg__list">
                    {list.map((it, i) => (
                        <li
                            key={it.id}
                            className="reorg__item"
                            draggable
                            onDragStart={() => onDragStart(i)}
                            onDragOver={(e) => onDragOver(e, i)}
                            onDragEnd={onDragEnd}
                        >
                            <span className="reorg__grip" aria-hidden="true">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <circle cx="9" cy="6" r="1.6" /><circle cx="15" cy="6" r="1.6" />
                                    <circle cx="9" cy="12" r="1.6" /><circle cx="15" cy="12" r="1.6" />
                                    <circle cx="9" cy="18" r="1.6" /><circle cx="15" cy="18" r="1.6" />
                                </svg>
                            </span>
                            <span className="reorg__pos">{i + 1}</span>
                            <span className="reorg__name">{it.label}</span>
                        </li>
                    ))}
                </ul>

                <footer className="reorg__foot">
                    <button type="button" className="reorg__cancel" onClick={onClose}>Cancelar</button>
                    <button type="button" className="reorg__apply" onClick={() => onApply(list.map(it => it.id))}>
                        Aplicar orden
                    </button>
                </footer>
            </div>
        </div>
    );
}
